import { AssetComponentsApi } from '@evimo/client/apis';
import { createApiConfiguration } from '~/app/lib/api-config';

const config = createApiConfiguration();

export const assetComponentsApi = new AssetComponentsApi(config);

export const assetComponentRequestInit = { credentials: 'include' as const };
